const LIVE_API_URL = "https://libraryofbooks-api.netlify.app/.netlify/functions/api";

const DEV_API_URL = "http://localhost:9000/.netlify/functions/api";

export const API_URL = LIVE_API_URL;
// export const API_URL = DEV_API_URL;
